namespace TabAurous.OMS {
    export interface PriceListDetailsRow {
        PriceListDetailsId?: number;
        PriceListId?: number;
        ItemListId?: number;
        ProductId?: number;
        ProductTypeName?: string;
        SubCategoryName?: string;
        AttributeId?: number;
        Attribute?: string;
        FromWt?: number;
        ToWt?: number;
        FromDate?: string;
        ToDate?: string;
        PurStdRate?: number;
        SaleStdRate?: number;
        MarkUp?: number;
        Amount?: number;
        ItemTypeId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneColorId?: number;
        ShapeId?: number;
        SieveId?: number;
        QualityId?: number;
        StoneSizeId?: number;
    }

    export namespace PriceListDetailsRow {
        export const idProperty = 'PriceListDetailsId';
        export const localTextPrefix = 'OMS.PriceListDetails';
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            PriceListDetailsId = "PriceListDetailsId",
            PriceListId = "PriceListId",
            ItemListId = "ItemListId",
            ProductId = "ProductId",
            ProductTypeName = "ProductTypeName",
            SubCategoryName = "SubCategoryName",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            FromWt = "FromWt",
            ToWt = "ToWt",
            FromDate = "FromDate",
            ToDate = "ToDate",
            PurStdRate = "PurStdRate",
            SaleStdRate = "SaleStdRate",
            MarkUp = "MarkUp",
            Amount = "Amount",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            StoneColorId = "StoneColorId",
            ShapeId = "ShapeId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId"
        }
    }
}
